import type { UseQueryResult } from '@tanstack/react-query';
import { isServer } from '../../utils/utils';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import { getFourGiftCardMessagesAsOneString } from '../utils/basket-utils';
import type { Basket } from './model';

export const useBasket = (): UseQueryResult<Basket> =>
    useBffGet(({ customer_id }) => `/customers/${customer_id}/basket`, [], [BffQueryKey.BASKET], {
        enabled: !isServer,
        refetchOnWindowFocus: 'always',
        keepPreviousData: true,
        select: (data: Basket): Basket => ({
            ...data,
            productItems: data.productItems?.map((pli) => ({
                ...pli,
                giftMessage: getFourGiftCardMessagesAsOneString(pli),
            })),
        }),
    });
